<template>
    <div class="container-fluid">
        <div class="row mb-3">
            <div class="col-sm-6">
                <h1 class="m-0 text-bold mb-2" style="font-size: 35px">Dashboard</h1>
                <h2 class="m-0 text-lg text-bold text-secondary">Welcome Back !</h2>
            </div>
        </div>

        <jumbotron-card :ib="ibAccount" />

        <div class="title my-3">
            <h2 class="m-0 text-bold mb-3" style="font-size: 35px">Overview</h2>
        </div>

        <div class="boxes">
            <div class="row">
                <div class="col-lg-4">
                    <template v-if="ibLandingLoaded">
                        <investors-invited-card :total="ibLanding.total_invited_investor" />
                    </template>
                    <template v-else>
                        <skeleton-info-card />
                    </template>
                </div>

                <div class="col-lg-4">
                    <type-ib-card :level="ibAccount.level" />
                </div>

                <div class="col-lg-4">
                    <template v-if="ibLandingLoaded">
                        <deposit-collected-card :total="ibLanding.total_deposit_collected" currency="$" />
                    </template>
                    <template v-else>
                        <skeleton-info-card />
                    </template>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <template v-if="investorAccountLoaded">
                    <current-bonus-card :referralCode="investorAccount.referral_code" :amount="ibLanding.total_bonus" currency="$" :level="ibAccount.level" />
                </template>
                <template v-else>
                    <skeleton-current-bonus-card />
                </template>              
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12 mt-3">
                <join-corporate-card />
            </div>
        </div>
    </div>
</template>

<script>
// import swal from 'sweetalert'
import axios from "axios";

import DepositCollectedCard from './DepositCollectedCard.vue';
import InvestorsInvitedCard from './InvestorsInvitedCard.vue';
import CurrentBonusCard from './CurrentBonusCard.vue';
import JoinCorporateCard from './JoinCorporateCard.vue';
import JumbotronCard from './JumbotronCard.vue';
import TypeIbCard from './TypeIbCard.vue'
import SkeletonInfoCard from './SkeletonInfoCard.vue';
import SkeletonCurrentBonusCard from './SkeletonCurrentBonusCard.vue';

export default {
    name : "DashboardIb",
    components : {
        DepositCollectedCard,
        InvestorsInvitedCard,
        CurrentBonusCard,
        JoinCorporateCard,
        JumbotronCard,
        TypeIbCard,
        SkeletonInfoCard,
        SkeletonCurrentBonusCard
    },
    props: {
        ib : {
            type : Object,
            default : function(){
                return {
                    level : undefined
                }
            }
        }
    },
    data(){
        return {
            ibAccount : this.ib,
            ibLanding : new Promise(function(){}),
            investorAccount : new Promise(function(){}),
            bonus : new Promise(function(){})
        }
    },
    computed : {
        ibLandingLoaded : function(){
            return !(this.ibLanding instanceof Promise)
        },

        investorAccountLoaded : function(){
            return !(this.investorAccount instanceof Promise)
        },
    },
    async mounted(){
        this.ibLanding = await this.getIbLanding()
        this.investorAccount = await this.getAccount()
        // this.bonus = await this.getIbBonus()
    },
    methods : {
        /**
         * Method untuk request IB landing
         */
        async getIbLanding(){
            let resp = await axios.get(`investor/${localStorage.user_id}/ib/landing/`)

            if( resp?.data?.data ){
                return resp.data.data
            }
            
            return undefined
        },

        /**
         * Method untuk request IB bonus
         */
        async getIbBonus(){
            let resp = await axios.get(`investor/${localStorage.user_id}/ib/bonus/`)

            if( resp?.data?.data ){
                return resp.data.data
            }
            
            return undefined
        },

        /**
         * Method untuk request IB requirements
         */
        async getIbRequirements(){
            let resp = await axios.get(`investor/${localStorage.user_id}/ib/requirements/`)

            if( resp?.data?.data ){
                return resp.data.data
            }
            
            return undefined
        },

        /**
         * Method untuk request investor profile
         */
        async getAccount(){
            let resp = await axios.get(`investor/${localStorage.user_id}/`)

            if( resp?.data?.data ){
                return resp.data.data
            }
            
            return undefined
        },
    }
}
</script>